import React, {Component, ReactElement, ReactNode} from 'react'
import NatMessageRepo from '../message/repository/NatMessageRepo'
import {
    MessageInfo,
    NatGetMessageList,
    SearchCondition,
    SearchConditionPageInfo,
    SearchResult,
} from './repository/NatGetMessageList'
import {
    ADMINISTORATOR_MODE,
    MESSAGE_CATEGORY,
    MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION,
    PREFECTURES_MASTER,
    PUBLICATION_STATUS,
    ROLE_FOR_ADMINISTRATOR,
    SET_EXISTENCE,
    VALID_OR_NOT_CHECK
} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {Nullable} from '../../../app/TypeHelpers'
import {NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo';
import {Messages} from '../../../Messages';
import ListSearchFormArea from '../../../styledComponents/adminPage/ListSearchFormArea';
import {SearchResultCountDisplayProps} from '../../../styledComponents/adminPage/SearchResultCountDisplay';
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents';
import PPTextField from '../../../components/shared/forms/PPTextField';
import {AdminDefaultMediumButton} from '../../../styledComponents/adminPage/Buttons';
import PPSelect from '../../../components/shared/forms/PPSelect';
import PPCheckboxGroup from '../../../components/shared/forms/PPCheckboxGroup';
import SearchPageActionArea from '../../../styledComponents/adminPage/SearchPageActionArea';
import {PageMainArea} from '../../../components/shared/hoc/withAdminPageTemplate';
import SortableTableHeader, {
    SortableTableHeaderCell
} from '../../../styledComponents/adminPage/SortablePaginationTableHeader';
import SortablePaginationTable from '../../../styledComponents/adminPage/SortablePaginationTable';
import SortablePaginationTableBody from '../../../styledComponents/adminPage/SortablePaginationTableBody';
import {SortDirection} from '@mui/material/TableCell';
import {SortOrder} from '../../../components/shared/SortOrder';
import {COMMON_CONSTANTS} from '../../../CommonConstants';
import {formatDateTimeForUpdateDate, formatForDateInput} from '../../../formatters/formatDate';
import {
    ConditionButtonCell,
    ConditionCategoryCell,
    ConditionColumNameCell,
    ConditionInputCell,
    ConditionTable,
    ConditionTableBody,
    ConditionTableRow,
} from '../../../styledComponents/adminPage/ConditionTable'
import {HKConstants} from '../../../HKConstants'
import AuthorityChecker from '../../../components/AuthorityChecker'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {HeadingAreaMessageParams} from '../../../components/shared/pageBaseComponents/HeadingAreaMessageComponent'
import NatCondominiumGroupSelectComponent from '../common/NatCondominiumGroupSelectComponent'
import {addEmptyData, NoSelectedValue} from '../../../componentHelper/selectHelper'
import {Location} from 'react-router-dom'

import {Link, TableCell, TableRow} from '@mui/material';
import {SelectChangeEvent} from '@mui/material/Select'

const KEY_SEARCH_CONDITION: string = 'adminMessageListPageSearchCondition'
const KEY_SELECTED_ADMINISTORATOR_MODE: string = 'selectedMode'
const KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID: string = 'loginUserCondominiumGroupId'
const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'

interface Props {
    messageRepo: NatMessageRepo,
    condominiumGroupRepo: NatCondominiumGroupRepo
    eventEmitter: EventEmitterExAdmin
    location: Location,
}

interface States {
    selectedCategoryId: string
    messageList: MessageInfo[]
    messageSearchResult: SearchResult
    condominiumGroup: NatGetCondominiumGroup
    searchCondition: SearchCondition
    searchConditionPageInfo: SearchConditionPageInfo
    searchConditionSortInfo: SortOrder[]
    noResultMessage: string
    isLoadCompleted: boolean
}

interface LastSearchCondition extends SearchCondition {
    pageNum?: number
}

class NatAdminMessageListPage extends Component<Props & AdminPagePropsSet, States> {
    roleId: Nullable<string>
    mode: Nullable<string>
    subSortKey: SortOrder = new SortOrder('messageId', 'asc')

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.mode = SessionStorageHelper.getStringItemOrNull(KEY_SELECTED_ADMINISTORATOR_MODE)
        this.roleId = SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID)
        const loginUserCondominiumGroupId: Nullable<number> =
            SessionStorageHelper.getNumberItemOrNull(KEY_LOGIN_USER_CONDOMINIUM_GROUP_ID)

        // 前回検索条件が保持されていればデフォルト値として設定する
        let lastSearchCondition: LastSearchCondition = {}
        const sessionStorageSearchCondition: string | null = window.sessionStorage.getItem(KEY_SEARCH_CONDITION)
        if (sessionStorageSearchCondition) {
            lastSearchCondition = JSON.parse(sessionStorageSearchCondition)
        } else {
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                lastSearchCondition.condominiumGroupId =
                    loginUserCondominiumGroupId ? loginUserCondominiumGroupId : undefined
                lastSearchCondition.condominiumMessageFlag = VALID_OR_NOT_CHECK.NOT.value
            }
            lastSearchCondition.doNotify = SET_EXISTENCE.values().map((master) => master.value).join(',')
        }


        let defaultSearchCondition: SearchCondition = {}

        if (Object.keys(lastSearchCondition).length) {
            defaultSearchCondition = {
                condominiumCd: lastSearchCondition.condominiumCd,
                condominiumName: lastSearchCondition.condominiumName,
                condominiumGroupId: lastSearchCondition.condominiumGroupId,
                extractStart: lastSearchCondition.extractStart,
                extractEnd: lastSearchCondition.extractEnd,
                categoryId: lastSearchCondition.categoryId,
                condominiumMessageFlag: lastSearchCondition.condominiumMessageFlag,
                doNotify: lastSearchCondition.doNotify,
            }
        }

        let defaultSearchConditionPage: SearchConditionPageInfo = {
            pageNum: COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS[0],
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        if (lastSearchCondition.pageNum) {
            defaultSearchConditionPage = {
                pageNum: Number(lastSearchCondition.pageNum),
                page: COMMON_CONSTANTS.FIRST_PAGE,
            }
        }


        this.state = {
            selectedCategoryId: '',
            messageList: [],
            messageSearchResult: {},
            condominiumGroup: {
                ['details']: null,
                ['informations']: [],
                ['requestError']: null,
                ['requestItemErrors']: [],
            },
            searchCondition: defaultSearchCondition,
            searchConditionPageInfo: {
                pageNum: defaultSearchConditionPage.pageNum,
                page: defaultSearchConditionPage.page,
            },
            searchConditionSortInfo: [
                new SortOrder('publishStartDate', 'desc'),
                new SortOrder('updateDatetime', 'desc'),
            ],
            noResultMessage: '',
            isLoadCompleted: false,
        }

        this.changeExtractStart = this.changeExtractStart.bind(this)
        this.changeExtractEnd = this.changeExtractEnd.bind(this)
        this.onChangeSelectedCondominiumGroupId = this.onChangeSelectedCondominiumGroupId.bind(this)
        this.changeCondominiumCd = this.changeCondominiumCd.bind(this)
        this.changeCondominiumName = this.changeCondominiumName.bind(this)
        this.changeDeliveryPrefectureCd = this.changeDeliveryPrefectureCd.bind(this)
        this.changeDeliveryAddress2 = this.changeDeliveryAddress2.bind(this)
        this.onClickSearchButton = this.onClickSearchButton.bind(this)
        this.changeCondominiumMessageFlag = this.changeCondominiumMessageFlag.bind(this)
        this.changeCategory = this.changeCategory.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.handleSortMessages = this.handleSortMessages.bind(this)
        this.registerMessage = this.registerMessage.bind(this)
        this.changeDoNotify = this.changeDoNotify.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        this.showInitialMessage()
        try {
            // 全体モード時のみ物件グループを取得
            if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
                const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                    this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                    (httpErrorOrNetworkError) => {
                        this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                    },
                )
                if (condominiumGroupResponse && condominiumGroupResponse.details) {
                    this.setState({condominiumGroup: condominiumGroupResponse})
                    // メッセージ取得
                    await this.getMessageList(
                        this.state.searchCondition,
                        this.state.searchConditionPageInfo,
                        this.state.searchConditionSortInfo,
                    )
                }
            } else {
                // メッセージ取得
                await this.getMessageList(
                    this.state.searchCondition,
                    this.state.searchConditionPageInfo,
                    this.state.searchConditionSortInfo,
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    showInitialMessage(): void {
        if (!this.props.location || !this.props.location.state) {
            return
        }
        const initialMessage: HeadingAreaMessageParams = this.props.location.state.initialMessage
        this.props.navigate(this.props.location.pathname, {replace: true})
        this.props.eventEmitter.showHeadingAreaMessage(initialMessage)
    }

    onChangeSelectedCondominiumGroupId(condomoniumGroupId: number): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumGroupId = condomoniumGroupId
        this.setState({searchCondition: searchCondition})
    }


    changeCondominiumCd(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumCd = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    changeCondominiumName(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.condominiumName = event.target.value
        this.setState({searchCondition: searchCondition})
    }

    changeDeliveryPrefectureCd(event: SelectChangeEvent<unknown>): void {
        const searchConditions = this.state.searchCondition
        if (event.target.value === NoSelectedValue) {
            searchConditions.deliveryTargetPrefectureCd = ''
        } else {
            const codeMaster = PREFECTURES_MASTER.codeToEnumConstants(event.target.value as string)
            if (codeMaster) {
                searchConditions.deliveryTargetPrefectureCd = event.target.value as string
            } else {
                searchConditions.deliveryTargetPrefectureCd = ''
            }
        }
        this.setState({searchCondition: searchConditions})
    }

    changeDeliveryAddress2(event: React.ChangeEvent<HTMLInputElement>): void {
        const searchConditions = this.state.searchCondition
        searchConditions.deliveryTargetAddress2 = event.target.value
        this.setState({searchCondition: searchConditions})
    }

    changeCategory(event: SelectChangeEvent<unknown>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        searchCondition.categoryId = event.target.value as string
        this.setState({searchCondition: searchCondition})
    }

    changeExtractStart(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.extractStart = formatForDateInput(date.toString())
        } else {
            searchCondition.extractStart = ''
        }
        this.setState({searchCondition: searchCondition})

    }

    changeExtractEnd(date: Nullable<Date>): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (date !== null) {
            searchCondition.extractEnd = formatForDateInput(date.toString())
        } else {
            searchCondition.extractEnd = ''
        }
        this.setState({searchCondition: searchCondition})
    }

    changeCondominiumMessageFlag(): void {
        const searchCondition: SearchCondition = this.state.searchCondition
        if (this.state.searchCondition.condominiumMessageFlag === VALID_OR_NOT_CHECK.VALID.value) {
            searchCondition.condominiumMessageFlag = VALID_OR_NOT_CHECK.NOT.value
        } else {
            searchCondition.condominiumMessageFlag = VALID_OR_NOT_CHECK.VALID.value
        }
        this.setState({searchCondition: searchCondition})
    }

    async getMessageList(
        searchCondition: SearchCondition,
        searchConditionPageInfo: SearchConditionPageInfo,
        searchConditionSortInfos: SortOrder[],
    ): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {
            const messageListResponse: Nullable<NatGetMessageList> = await this.props.asyncCallFunction(
                this.props.messageRepo.getMessageList.bind(
                    this.props.messageRepo,
                    searchCondition, searchConditionPageInfo,
                    [...searchConditionSortInfos, this.subSortKey]),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (messageListResponse && messageListResponse.details) {
                let noResultMessage: string = ''
                if (messageListResponse.details.searchResult.total === 0) {
                    if (
                        searchCondition.condominiumGroupId === undefined &&
                        searchCondition.condominiumCd === undefined &&
                        searchCondition.condominiumName === undefined &&
                        searchCondition.deliveryTargetPrefectureCd === undefined &&
                        searchCondition.deliveryTargetAddress2 === undefined &&
                        searchCondition.extractStart === undefined &&
                        searchCondition.extractEnd === undefined &&
                        searchCondition.categoryId === undefined &&
                        searchCondition.condominiumMessageFlag === undefined &&
                        searchCondition.doNotify === undefined
                    ) {
                        noResultMessage = Messages.IOPCC0015.toString('メッセージ')
                    } else {
                        noResultMessage = Messages.IOPCC0014.toString('')
                    }
                }
                this.setState({
                    noResultMessage: noResultMessage,
                    messageList: messageListResponse.details.messageInfo,
                    messageSearchResult: messageListResponse.details.searchResult,
                })
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    registerMessage(): void {
        this.props.navigate('/admin/messageRegister')
    }

    getDispPublishStatus(publishStatus: string): string {
        const publicationStatusCode = PUBLICATION_STATUS.codeToEnumConstants(publishStatus)
        if (publicationStatusCode) {
            return publicationStatusCode.label
        } else {
            return ''
        }
    }

    getPrefectureName(prefectureCd: string): string {
        if (prefectureCd) {
            return PREFECTURES_MASTER.codeToEnumConstants(prefectureCd).label
        } else {
            return ''
        }
    }

    getCheckMark(value: string): string {
        const validOrNotCheck = VALID_OR_NOT_CHECK.codeToEnumConstants(value)
        if (validOrNotCheck) {
            return validOrNotCheck.label
        } else {
            return ''
        }
    }

    getDispMessageCategory(messageCategoryId: string): string {
        const messageCategory = MESSAGE_CATEGORY.codeToEnumConstants(messageCategoryId)
        if (messageCategory) {
            return messageCategory.label
        } else {
            return ''
        }
    }

    getFormatForDateInputAllowNull(publishEndDate: string): string {
        if (publishEndDate !== null) {
            return formatForDateInput(publishEndDate)
        } else {
            return publishEndDate
        }
    }

    searchResults(): SearchResultCountDisplayProps {
        if (this.state.messageList.length === 0) {
            return {noResultMessage: this.state.noResultMessage}
        }

        return {
            totalCount: this.state.messageSearchResult.total ? this.state.messageSearchResult.total : undefined,
            rowsPerPage: this.state.searchConditionPageInfo.pageNum,
            page: this.state.searchConditionPageInfo.page,
        }
    }

    judgeCheckDoNotify(doNotify: string): boolean {
        if (!this.state.searchCondition || !this.state.searchCondition.doNotify) {
            return false
        }
        const setArray: string[] = this.state.searchCondition.doNotify.split(',')
        return setArray.indexOf(doNotify) >= 0
    }

    changeDoNotify(label: string, checked: boolean): void {
        const checkedStatus = SET_EXISTENCE.values().filter(set => {
            return set.label === label
        })

        if (this.state.searchCondition.doNotify) {
            const checkedStatusArray: string[] = this.state.searchCondition.doNotify.split(',')
            if (checked) {
                checkedStatusArray.push(checkedStatus[0].value)
            } else {
                checkedStatusArray.splice(checkedStatusArray.indexOf(checkedStatus[0].value), 1)
            }
            const searchCondition = this.state.searchCondition
            searchCondition.doNotify = checkedStatusArray.join(',')
            this.setState({searchCondition: searchCondition})
        } else {
            if (checked) {
                const searchCondition = this.state.searchCondition
                searchCondition.doNotify = checkedStatus[0].value
                this.setState({searchCondition: searchCondition})
            }
        }
    }

    async onClickSearchButton(): Promise<void> {
        this.beforeUserAction()
        // 検索条件を保持
        const lastSearchCondition: LastSearchCondition = {
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            deliveryTargetPrefectureCd: this.state.searchCondition.deliveryTargetPrefectureCd,
            deliveryTargetAddress2: this.state.searchCondition.deliveryTargetAddress2,
            extractStart: this.state.searchCondition.extractStart,
            extractEnd: this.state.searchCondition.extractEnd,
            categoryId: this.state.searchCondition.categoryId,
            condominiumMessageFlag: this.state.searchCondition.condominiumMessageFlag,
            doNotify: this.state.searchCondition.doNotify,
            pageNum: this.state.searchConditionPageInfo.pageNum,

        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))
        const searchConditionPageInfo: SearchConditionPageInfo = {
            pageNum: this.state.searchConditionPageInfo.pageNum,
            page: COMMON_CONSTANTS.FIRST_PAGE,
        }
        await this.getMessageList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    renderPublishRange(): ReactNode {

        if (this.mode !== ADMINISTORATOR_MODE.ALL.value) {
            return (<></>)
        }

        return (
            <>
                <ConditionTableRow>
                    <ConditionCategoryCell rowSpan={4}>公開範囲</ConditionCategoryCell>
                    <ConditionColumNameCell>物件グループを選択</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        {
                            this.state.condominiumGroup &&
                            this.state.condominiumGroup.details &&
                            <NatCondominiumGroupSelectComponent
                                condominiumGroup={this.state.condominiumGroup.details}
                                defaultValue={Number(this.state.searchCondition.condominiumGroupId)}
                                onChangeSelectedCondominiumGroupId={this.onChangeSelectedCondominiumGroupId}
                                requiredFlag={true}
                                eventKeys={['condominiumGroupId']}
                                eventEmitter={this.props.eventEmitter}
                                autoFocus={true}
                            >
                            </NatCondominiumGroupSelectComponent>
                        }
                    </ConditionInputCell>
                    <ConditionButtonCell></ConditionButtonCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionColumNameCell>物件コード</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <PPTextField
                            InputProps={{
                                inputProps: {
                                    maxLength: 6,
                                },
                            }}
                            required
                            fullWidth
                            onChange={this.changeCondominiumCd}
                            defaultValue={this.state.searchCondition.condominiumCd}
                            eventKeys={['condominiumCd']}
                            eventEmitter={this.props.eventEmitter}
                        />
                    </ConditionInputCell>
                    <ConditionButtonCell></ConditionButtonCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionColumNameCell>物件名</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <PPTextField
                            InputProps={{
                                inputProps: {
                                    maxLength: 50,
                                },
                            }}
                            required
                            fullWidth
                            onChange={this.changeCondominiumName}
                            defaultValue={this.state.searchCondition.condominiumName}
                            eventKeys={['condominiumName']}
                            eventEmitter={this.props.eventEmitter}
                        />
                    </ConditionInputCell>
                    <ConditionButtonCell></ConditionButtonCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionColumNameCell>指定地域</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <LeftRowFlexContainer>
                            <TermWrapper>
                                <FlexBasis>
                                    <PPSelect
                                        data={
                                            addEmptyData(PREFECTURES_MASTER.values(),
                                                '都道府県を選択してください',
                                            )}
                                        onChange={this.changeDeliveryPrefectureCd}
                                        eventKeys={['deliveryTargetPrefectureCd']}
                                        eventEmitter={this.props.eventEmitter}
                                        value={this.state.searchCondition.deliveryTargetPrefectureCd}
                                    />
                                </FlexBasis>
                                <TermTxt>市区町村</TermTxt>
                            </TermWrapper>
                            <TermWrapper>
                                <FlexBasis>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                maxLength: 50,
                                            },
                                        }}
                                        fullWidth
                                        onChange={this.changeDeliveryAddress2}
                                        defaultValue={this.state.searchCondition.deliveryTargetAddress2}
                                    />
                                </FlexBasis>
                            </TermWrapper>
                        </LeftRowFlexContainer>
                    </ConditionInputCell>
                </ConditionTableRow>
            </>
        )

    }

    renderMessageInfo(): ReactNode {
        return (
            <>
                <ConditionTableRow>
                    <ConditionCategoryCell rowSpan={4}>メッセージ情報</ConditionCategoryCell>
                    <ConditionColumNameCell>抽出範囲</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        <LeftRowFlexContainer>
                            <TermWrapper>
                                <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                    <PPDatePicker
                                        onChangeDate={this.changeExtractStart}
                                        value={(this.state.searchCondition.extractStart &&
                                            this.state.searchCondition.extractStart !== '') ?
                                            new Date(this.state.searchCondition.extractStart) : null
                                        }

                                        maxDate=
                                            {(this.state.searchCondition.extractEnd &&
                                                this.state.searchCondition.extractEnd !== '') ?
                                                new Date(this.state.searchCondition.extractEnd) : undefined
                                            }
                                        autoFocus={(this.mode === ADMINISTORATOR_MODE.ALL.value) ? false : true}
                                    />
                                </FlexBasis>
                                <TermTxt>から</TermTxt>
                            </TermWrapper>
                            <TermWrapper>
                                <FlexBasis style={{paddingBottom: 4, paddingTop: 8}}>
                                    <PPDatePicker
                                        onChangeDate={this.changeExtractEnd}
                                        value={(this.state.searchCondition.extractEnd &&
                                            this.state.searchCondition.extractEnd !== '') ?
                                            new Date(this.state.searchCondition.extractEnd) : null
                                        }
                                        minDate={(this.state.searchCondition.extractStart &&
                                            this.state.searchCondition.extractStart !== '') ?
                                            new Date(this.state.searchCondition.extractStart) : undefined
                                        }
                                    />
                                </FlexBasis>
                                <TermTxt>まで</TermTxt>
                            </TermWrapper>
                        </LeftRowFlexContainer>
                    </ConditionInputCell>
                </ConditionTableRow>
                <ConditionTableRow>
                    <ConditionColumNameCell>カテゴリを選択</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        {this.renderCategoriesSelect()}
                    </ConditionInputCell>
                    {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                        <ConditionButtonCell></ConditionButtonCell>
                    }
                </ConditionTableRow>
                {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                    <ConditionTableRow>
                        <ConditionColumNameCell></ConditionColumNameCell>
                        <ConditionInputCell colSpan={2}>
                            {this.renderCondominiumMessageFlag()}
                        </ConditionInputCell>
                    </ConditionTableRow>
                }
                <ConditionTableRow>
                    <ConditionColumNameCell>通知有無</ConditionColumNameCell>
                    <ConditionInputCell colSpan={2}>
                        {this.renderDoNotifyCheckBox()}
                    </ConditionInputCell>
                    <ConditionButtonCell>
                        <AdminDefaultMediumButton
                            onClick={this.onClickSearchButton}>
                            メッセージを検索する
                        </AdminDefaultMediumButton>
                    </ConditionButtonCell>
                </ConditionTableRow>
            </>
        )
    }

    renderCondominiumMessageFlag(): ReactNode {

        const labels: { label: string, checked: boolean }[] = [{
            label: '個別物件向けの情報を抽出する',
            checked: this.state.searchCondition.condominiumMessageFlag === VALID_OR_NOT_CHECK.VALID.value,
        }]
        return (
            <LeftRowFlexContainer>
                <PPCheckboxGroup
                    data={labels}
                    onChangeChecked={this.changeCondominiumMessageFlag}
                />
            </LeftRowFlexContainer>
        )
    }

    renderDoNotifyCheckBox(): ReactNode {
        const labels: { label: string, checked: boolean }[] = []
        const doNotifyMaster = SET_EXISTENCE.values()

        doNotifyMaster.map((doNotify) => (
            labels.push(
                {
                    label: doNotify.label,
                    checked: this.judgeCheckDoNotify(doNotify.value),
                },
            )
        ))

        return (
            <PPCheckboxGroup
                row
                data={labels}
                onChangeChecked={this.changeDoNotify}
            />
        )
    }

    renderCategoriesSelect(): ReactNode {
        const categories = (this.roleId === ROLE_FOR_ADMINISTRATOR.ASSOC.value) ?
            MESSAGE_CATEGORY_SEARCH_FOR_MANAGEMENT_UNION.values().map((category) => {
                return ({
                    label: category.label,
                    value: `${category.value}`,
                })
            }) : MESSAGE_CATEGORY.values().map((category) => {
                return ({
                    label: category.label,
                    value: `${category.value}`,
                })
            })
        const categoryOptions = [{
            label: '全てのカテゴリ',
            value: '',
        }, ...categories]

        return (
            <PPSelect
                eventEmitter={this.props.eventEmitter}
                data={categoryOptions}
                onChange={this.changeCategory}
                value={this.state.searchCondition.categoryId}
            />
        )
    }

    async handleChangePage(
        event: React.MouseEvent<HTMLButtonElement, MouseEvent> | null,
        newPage: number,
    ): Promise<void> {
        this.beforeUserAction()
        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.page = newPage
        await this.getMessageList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    beforeUserAction(): void {
        this.props.eventEmitter.clearHeadingAreaMessage()
    }


    async handleSortMessages(sortKey: string): Promise<void> {
        this.beforeUserAction()

        let sortDirection: SortDirection = this.getSortDirection(sortKey)
        if (sortDirection === false || sortDirection === 'desc') {
            sortDirection = 'asc'
        } else {
            sortDirection = 'desc'
        }

        const sortOrders: SortOrder[] = [new SortOrder(sortKey, sortDirection)]
        await this.getMessageList(
            this.state.searchCondition,
            this.state.searchConditionPageInfo,
            sortOrders,
        )
        this.setState({searchConditionSortInfo: sortOrders})
    }

    async handleChangeRowsPerPage(event: React.ChangeEvent<HTMLInputElement>): Promise<void> {
        this.beforeUserAction()

        // 検索条件を保持
        const lastSearchCondition: LastSearchCondition = {
            condominiumCd: this.state.searchCondition.condominiumCd,
            condominiumName: this.state.searchCondition.condominiumName,
            condominiumGroupId: this.state.searchCondition.condominiumGroupId,
            extractStart: this.state.searchCondition.extractStart,
            extractEnd: this.state.searchCondition.extractEnd,
            categoryId: this.state.searchCondition.categoryId,
            condominiumMessageFlag: this.state.searchCondition.condominiumMessageFlag,
            pageNum: Number(event.target.value),

        }
        SessionStorageHelper.setItem(KEY_SEARCH_CONDITION, JSON.stringify(lastSearchCondition))

        const searchConditionPageInfo: SearchConditionPageInfo = this.state.searchConditionPageInfo
        searchConditionPageInfo.pageNum = Number(event.target.value)
        searchConditionPageInfo.page = COMMON_CONSTANTS.FIRST_PAGE
        await this.getMessageList(
            this.state.searchCondition,
            searchConditionPageInfo,
            this.state.searchConditionSortInfo,
        )
        this.setState({searchConditionPageInfo: searchConditionPageInfo})
    }

    renderMessageRecord(message: MessageInfo): ReactElement {

        const messageUrl: string = `/admin/message/${message.messageId}`
        return (
            <TableRow key={message.messageId}>
                <TableCellWordBreakAll align={'left'}><Link href={messageUrl} underline="hover">{message.title}
                </Link></TableCellWordBreakAll>
                <TableCell align={'left'} style={{width: '95px'}}>
                    {this.getDispMessageCategory(message.categoryId)}
                </TableCell>
                <TableCell align={'left'} style={{width: '70px'}}>
                    {message.authorName}
                </TableCell>
                <TableCell align={'left'} style={{width: '115px'}}>
                    {formatForDateInput(message.publishStartDate)}
                </TableCell>
                <TableCell align={'left'} style={{width: '115px'}}>
                    {this.getFormatForDateInputAllowNull(message.publishEndDate)}
                </TableCell>
                {this.mode === ADMINISTORATOR_MODE.ALL.value && message.condominiumName &&
                    <TableCellWordBreakAll align={'left'} style={{width: '130px'}}>
                        {message.condominiumName}
                    </TableCellWordBreakAll>
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value && !message.condominiumName &&
                    <TableCellWordBreakAll align={'left'} style={{width: '130px'}}>
                        {message.condominiumGroupName}
                    </TableCellWordBreakAll>
                }
                {this.mode === ADMINISTORATOR_MODE.ALL.value &&
                    <TableCellWordBreakAll align={'left'} style={{width: '90px'}}>
                        {this.getPrefectureName(message.deliveryTargetPrefectureCd)}
                        {message.deliveryTargetAddress2}
                    </TableCellWordBreakAll>
                }
                <TableCell align={'center'} style={{width: '85px'}}>
                    {this.getCheckMark(message.topFixed)}
                </TableCell>
                <TableCell align={'center'} style={{width: '85px'}}>
                    {this.getCheckMark(message.doNotify)}
                </TableCell>
                <TableCell align={'left'} style={{width: '80px'}}>
                    {this.getDispPublishStatus(message.publishStatus)}
                </TableCell>
                <TableCell align={'left'} style={{width: '70px'}}>
                    {message.updaterName}
                </TableCell>
                <TableCell align={'left'} style={{width: '115px'}}>
                    {formatDateTimeForUpdateDate(message.updateDatetime)}
                </TableCell>
            </TableRow>
        )
    }

    renderMessageTable(messageList: MessageInfo[]): Nullable<ReactElement> {
        if (messageList.length === 0) {
            return null
        }
        let headers: SortableTableHeaderCell[] = []

        if (this.mode === ADMINISTORATOR_MODE.ALL.value) {
            headers = [
                {id: 'title', label: 'タイトル', align: 'left'},
                {id: 'category', label: 'カテゴリ', align: 'left'},
                {id: 'authorName', label: '作成者', align: 'left'},
                {
                    id: 'publishStartDate',
                    label: '掲載開始',
                    sortable: true,
                    direction: this.getSortDirection('publishStartDate'),
                    align: 'left',
                },
                {
                    id: 'publishEndDate',
                    label: '掲載終了',
                    sortable: true,
                    direction: this.getSortDirection('publishEndDate'),
                    align: 'left',
                },
                {id: 'deliveryGroupOrCondominium', label: '配信先グループ/物件', align: 'left'},
                {id: 'deliveryTarget', label: '指定地域', align: 'left'},
                {id: 'topFixed', label: '上位固定', sortable: true, direction: this.getSortDirection('topFixed')},
                {id: 'doNotify', label: '通知', sortable: true, direction: this.getSortDirection('doNotify')},
                {id: 'status', label: '掲載状態', align: 'left'},
                {id: 'updaterName', label: '更新者', align: 'left'},
                {
                    id: 'updateDatetime',
                    label: '更新日時',
                    sortable: true,
                    direction: this.getSortDirection('updateDatetime'),
                    align: 'left',
                },
            ]
        } else {
            headers = [
                {id: 'title', label: 'タイトル', align: 'left'},
                {id: 'category', label: 'カテゴリ', align: 'left'},
                {id: 'authorName', label: '作成者', align: 'left'},
                {
                    id: 'publishStartDate',
                    label: '掲載開始',
                    sortable: true,
                    direction: this.getSortDirection('publishStartDate'),
                    align: 'left',
                },
                {
                    id: 'publishEndDate',
                    label: '掲載終了',
                    sortable: true,
                    direction: this.getSortDirection('publishEndDate'),
                    align: 'left',
                },
                {id: 'topFixed', label: '上位固定', sortable: true, direction: this.getSortDirection('topFixed')},
                {id: 'doNotify', label: '通知', sortable: true, direction: this.getSortDirection('doNotify')},
                {id: 'status', label: '掲載状態', align: 'left'},
                {id: 'updaterName', label: '更新者', align: 'left'},
                {
                    id: 'updateDatetime',
                    label: '更新日時',
                    sortable: true,
                    direction: this.getSortDirection('updateDatetime'),
                    align: 'left',
                },
            ]
        }


        return (
            <SortablePaginationTable
                paginationProps={{
                    count: this.state.messageSearchResult.total ? this.state.messageSearchResult.total : 0,
                    rowsPerPage:
                        this.state.searchConditionPageInfo.pageNum ? this.state.searchConditionPageInfo.pageNum : 0,
                    page: this.state.searchConditionPageInfo.page ? this.state.searchConditionPageInfo.page : 0,
                    onPageChange: this.handleChangePage,
                    onRowsPerPageChange: this.handleChangeRowsPerPage,
                }}
            >

                <SortableTableHeader
                    noWrap={this.mode !== ADMINISTORATOR_MODE.ALL.value}
                    headers={headers}
                    onSortOrderChange={this.handleSortMessages}
                />
                <SortablePaginationTableBody>
                    {this.state.messageList.map(
                        message => this.renderMessageRecord(message),
                    )}
                </SortablePaginationTableBody>
            </SortablePaginationTable>
        )
    }

    getSortDirection(sortKey: string): SortDirection {
        const sortOrder: SortOrder | undefined =
            this.state.searchConditionSortInfo.find(order => order.sortKey === sortKey)
        if (sortOrder === undefined) {
            return false
        }
        return sortOrder.sortDirection
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <ListSearchFormArea
                    searchResult={this.searchResults()}
                    onEnterKey={this.onClickSearchButton}
                >
                    <ConditionTable>
                        <ConditionTableBody>
                            {this.renderPublishRange()}
                            {this.renderMessageInfo()}
                        </ConditionTableBody>
                    </ConditionTable>
                </ListSearchFormArea>
                <SearchPageActionArea>
                    <AuthorityChecker permittedAuthorities={HKConstants.CMN.AUTH.EDIT_MESSAGE}>
                        <AdminDefaultMediumButton onClick={this.registerMessage}>
                            新規
                        </AdminDefaultMediumButton>
                    </AuthorityChecker>
                </SearchPageActionArea>
                <PageMainArea>
                    {this.renderMessageTable(this.state.messageList)}
                </PageMainArea>
            </>
        )
    }
}

export default createAdminPage(NatAdminMessageListPage)

const TableCellWordBreakAll = styled(TableCell)`
  &.MuiTableCell-root {
    word-break: break-all;
  }
`
const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

